import React, {FC} from "react"

import {StyledFeedItem} from "./styled/FeedItem"

import NewItem from "./NewItem"

interface Props {
  isNew?: boolean
}

const FeedItem: FC<Props> = ({children, isNew, ...props}) => {
  return (
    <StyledFeedItem {...props}>
      {isNew && <NewItem />}
      {children}
    </StyledFeedItem>
  )
}

FeedItem.defaultProps = {
  isNew: false
}

export default FeedItem
